import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "n-2001",
    title: "《星河彼岸》口碑持续走高，科幻外壳下的人性叙事引发热议",
    category: "影视新闻",
    source: "糖心传媒",
    publishTime: "2025-10-15T09:20:00",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20key%20visual%20with%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20crimson%20nebula%2C%20warm%20orange%20space%20glow%2C%20editorial%20news%20thumbnail%2C%20clean%20composition&width=800&height=500&seq=txn-star-news-01&orientation=landscape",
    lead:
      "上映首周票房突破预期，《星河彼岸》凭借扎实的剧本与震撼的视听语言收获大量好评，观众讨论集中在影片对离别与记忆的细腻处理。",
    content: [
      "由顾清野执导的科幻剧情片《星河彼岸》自上映以来热度持续攀升。影片以一艘驶向未知星系的星际方舟为舞台，把宏大的宇宙想象与细腻的情感叙事缝合在一起。",
      "不少观众表示，影片最动人的并非视觉奇观，而是船长在漫长航程中对往事的回溯。有影评人指出，导演用科幻的外壳包裹了一个关于告别的普世故事，让类型片拥有了更深的余味。",
      "据片方透露，影片拍摄期间搭建了多个实景舱室，最大限度还原失重环境下的生活细节。目前影片仍在各大影院热映中，后续将推出幕后纪录片。",
    ],
  },
  {
    id: "n-2002",
    title: "年度古装大剧《京华烟云录》开播，年代质感获一致好评",
    category: "剧集动态",
    source: "糖心传媒",
    publishTime: "2025-10-14T16:40:00",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20Chinese%20period%20drama%20scene%20with%20elegant%20palace%20corridors%20and%20hanging%20lanterns%20at%20dusk%2C%20warm%20crimson%20and%20gold%20tones%2C%20editorial%20news%20thumbnail&width=800&height=500&seq=txn-jinghua-news-02&orientation=landscape",
    lead:
      "《京华烟云录》首播即登上热搜，精致的年代置景与克制的表演风格被观众称为年度最有质感的古装剧之一。",
    content: [
      "《京华烟云录》围绕江南望族沈家的两位小姐展开，讲述她们在时代洪流中截然不同的命运选择。剧集播出后，观众对其美术与服化道的还原度赞不绝口。",
      "主创团队透露，为了呈现真实的年代氛围，剧组在置景上投入了大量精力，多个主要场景均为实景搭建。",
      "目前剧集已更新至第 12 集，主线矛盾逐渐展开，后续剧情走向备受期待。",
    ],
  },
  {
    id: "n-2003",
    title: "《向往的山野》新一期录制曝光，嘉宾阵容引发期待",
    category: "综艺花絮",
    source: "娱乐前线",
    publishTime: "2025-10-13T11:10:00",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20mountain%20cabin%20at%20golden%20hour%20with%20friends%20gathering%20and%20bonfire%20smoke%2C%20warm%20golden%20tones%2C%20editorial%20news%20thumbnail%2C%20relaxed%20lifestyle%20mood&width=800&height=500&seq=txn-wild-news-03&orientation=landscape",
    lead:
      "慢生活真人秀《向往的山野》最新一期录制花絮曝光，几位新嘉宾的加入让这座山里的小院再度热闹起来。",
    content: [
      "作为一档主打慢节奏生活体验的综艺，《向往的山野》凭借治愈的氛围积累了大批忠实观众。最新一期的录制花絮中，嘉宾们一起下地劳作、合力做饭，画面温馨而真实。",
      "节目组表示，本季会走进更多不同的地域，呈现不同地方的风土人情与生活方式。",
      "新一期节目将于本周六中午 12 点与观众见面。",
    ],
  },
  {
    id: "n-2004",
    title: "悬疑剧《城市之光》口碑逆袭，烧脑剧情成讨论焦点",
    category: "剧集动态",
    source: "糖心传媒",
    publishTime: "2025-10-12T20:00:00",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20night%20cityscape%20from%20above%20with%20warm%20amber%20street%20lights%20against%20deep%20shadows%2C%20urban%20mystery%20atmosphere%2C%20editorial%20news%20thumbnail&width=800&height=500&seq=txn-city-news-04&orientation=landscape",
    lead:
      "《城市之光》凭借严密的推理逻辑与层层反转的剧情实现口碑逆袭，相关话题连续多日占据讨论榜前列。",
    content: [
      "《城市之光》讲述一名背负旧案心结的刑警与一位心理侧写师携手破案的故事。剧集前期节奏克制，随着主线推进，隐藏的线索逐渐浮出水面。",
      "观众热衷于在社交平台复盘每一处细节，多个看似无关的道具都被指出是重要伏笔。",
      "该剧目前更新至第 24 集，导演表示结局会给出一个令人信服的答案。",
    ],
  },
  {
    id: "n-2005",
    title: "电影《山海拾光》发布最新预告，手绘美学惊艳观众",
    category: "影视新闻",
    source: "动画观察",
    publishTime: "2025-10-11T14:30:00",
    cover:
      "https://readdy.ai/api/search-image?query=Hand%20painted%20animated%20fantasy%20landscape%20of%20floating%20mountains%20and%20a%20sea%20of%20glowing%20clouds%20at%20sunset%2C%20warm%20orange%20tones%2C%20editorial%20news%20thumbnail&width=800&height=500&seq=txn-shanhai-news-05&orientation=landscape",
    lead:
      "动画电影《山海拾光》发布最新预告，极具东方韵味的手绘画面与悠扬配乐让不少观众直呼期待。",
    content: [
      "《山海拾光》取材于上古神话，讲述失去记忆的小女孩与受伤神兽结伴寻找拾光之树的故事。",
      "最新预告中，影片展示了多个大场景，云雾缭绕的仙山与流光溢彩的云海营造出浓郁的东方奇幻氛围。",
      "影片团队表示，全片坚持手绘与数字技术结合的方式，希望在视觉上呈现独特的艺术质感。",
    ],
  },
  {
    id: "n-2006",
    title: "《星光大赏》决赛在即，四强战队蓄势待发",
    category: "综艺花絮",
    source: "娱乐前线",
    publishTime: "2025-10-10T19:00:00",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20warm%20crimson%20and%20orange%20spotlights%20and%20audience%20silhouettes%2C%20energetic%20concert%20atmosphere%2C%20editorial%20news%20thumbnail&width=800&height=500&seq=txn-starlight-news-06&orientation=landscape",
    lead:
      "音乐竞演综艺《星光大赏》即将迎来决赛之夜，四支战队的最终舞台曲目备受关注。",
    content: [
      "本季《星光大赏》自开播以来热度居高不下，导师与选手的多次神仙合作成为节目亮点。",
      "据节目组透露，决赛将采用现场乐队全程伴奏的形式，力求为观众带来沉浸式的音乐体验。",
      "决赛之夜将于本周五晚 20:00 直播。",
    ],
  },
  {
    id: "n-2007",
    title: "年代剧《我们的十年》收官，观众直呼后劲十足",
    category: "剧集动态",
    source: "糖心传媒",
    publishTime: "2025-10-09T21:20:00",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20old%20Chinese%20residential%20neighborhood%20at%20sunset%20with%20warm%20sepia%20tones%2C%20heartwarming%20emotional%20mood%2C%20editorial%20news%20thumbnail&width=800&height=500&seq=txn-tenyears-news-07&orientation=landscape",
    lead:
      "《我们的十年》迎来大结局，五个主角的最终走向引发观众热烈讨论，许多人为剧中真实的年代细节动容。",
    content: [
      "《我们的十年》从上世纪九十年代的一座老厂区家属院讲起，记录五个伙伴跨越十年的成长。",
      "大结局播出后，观众纷纷在评论区分享自己与剧中场景相似的记忆，称其唤起了强烈的共鸣。",
      "主创表示，希望用这部剧留下一代人共同的青春印记。",
    ],
  },
  {
    id: "n-2008",
    title: "喜剧综艺《喜剧之王现场》新季回归，笑点再升级",
    category: "综艺花絮",
    source: "娱乐前线",
    publishTime: "2025-10-08T12:00:00",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20lit%20comedy%20stage%20with%20a%20single%20microphone%20and%20red%20curtains%2C%20playful%20spotlight%20beams%2C%20editorial%20news%20thumbnail%2C%20vibrant%20tone&width=800&height=500&seq=txn-comedy-news-08&orientation=landscape",
    lead:
      "新一季《喜剧之王现场》正式回归，全新赛制与更强嘉宾阵容让节目的笑点密度再度提升。",
    content: [
      "作为深受观众喜爱的喜剧综艺，《喜剧之王现场》坚持用真实的生活观察创作段子。",
      "新一季引入了更多跨界喜剧人，舞台形式也更加多样。",
      "节目每周日晚 21:00 更新，持续为观众带来欢乐。",
    ],
  },
  {
    id: "n-2009",
    title: "《极速边界》幕后特辑曝光，实拍赛车场面震撼",
    category: "影视新闻",
    source: "糖心传媒",
    publishTime: "2025-10-07T15:45:00",
    cover:
      "https://readdy.ai/api/search-image?query=Night%20street%20racing%20scene%20with%20glowing%20red%20tail%20lights%20and%20motion%20blur%20on%20wet%20asphalt%2C%20high%20octane%20cinematic%20atmosphere%2C%20editorial%20news%20thumbnail&width=800&height=500&seq=txn-speed-news-09&orientation=landscape",
    lead:
      "动作电影《极速边界》发布幕后特辑，影片中大量赛车场面均为实拍完成，制作难度令人惊叹。",
    content: [
      "《极速边界》讲述退役车手为替师父还债重返赛道的故事，其中多场竞速戏份成为影片最大看点。",
      "特辑中展示了剧组为拍攝高难度弯道漂移所做的周密准备，专业特技车手的参与保证了画面的真实感。",
      "影片目前仍在各大平台热映。",
    ],
  },
  {
    id: "n-2010",
    title: "糖心传媒年度片单发布，多部重磅作品蓄势待发",
    category: "行业资讯",
    source: "糖心传媒",
    publishTime: "2025-10-06T10:00:00",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20editorial%20collage%20of%20movie%20posters%20stacked%20with%20warm%20crimson%20and%20orange%20accents%2C%20clean%20modern%20design%2C%20news%20thumbnail%20style&width=800&height=500&seq=txn-annual-news-10&orientation=landscape",
    lead:
      "糖心传媒正式公布年度片单，涵盖电影、剧集与综艺三大板块，多部备受期待的作品首次亮相。",
    content: [
      "在最新的年度片单发布会上，糖心传媒公布了一批即将与观众见面的重点作品，题材覆盖科幻、悬疑、现实、古装等多个方向。",
      "平台表示，未来将继续深耕优质内容，为观众带来更多兼具口碑与热度的影视作品。",
      "更多作品详情与上线时间将在后续陆续公布，敬请关注。",
    ],
  },
];